import Persistable from "../../storage/persistable";

export default class Team extends Persistable {
    constructor(name) {
        super();
        this.teamId = null;
        this.teamName = name;
        this.rpi = null;
        this.players = [];
    }

    getTeamName() {
        return this.teamName;
    }

    getPlayerByUniform(uniform) {
        return this.players.filter((p) => p.uniform === uniform)[0];
    }

    toJSON() {
        return super.toJSON([], ["players", "season"]);
    }
}
